// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb794c58","337":"3c90e5b4","453":"4e7eef52","732":"77e22de7"}[chunkId] + ".chunk.js";
};